import { connect } from 'react-redux';
import lifecycle from 'recompose/lifecycle';

import {
  fetchDecisionSplitObjects,
  fetchDecisionSplitUserData,
  fetchIsHCOEnabled,
  fetchJourneyMetadata,
  fetchLocalization,
  journeyBuilderDecisionSplitStart,
} from '../actions/JourneyBuilder';
import JourneyBuilderDecisionSplitComponent from './JourneyBuilderDecisionSplitComponent';

export const enhance = lifecycle({
  componentDidMount() {
    this.props.journeyBuilderDecisionSplitStart();
  },
  componentDidUpdate(prevProps) {
    const { culture, currentMID, fetchDecisionSplitObjects } = this.props;

    if (culture !== prevProps.culture || currentMID !== prevProps.currentMID) {
      if (culture && currentMID > 0) {
        fetchDecisionSplitObjects(culture, currentMID);
      }
    }
  },
})(JourneyBuilderDecisionSplitComponent);

export default connect(
  ({
    journeyBuilderArea: {
      JourneyBuilderSettings: { culture, currentMID, journeyId, tokens },
    },
  }) => ({
    culture,
    currentMID,
    journeyId,
    tokens,
  }),
  {
    fetchDecisionSplitObjects,
    fetchDecisionSplitUserData,
    fetchIsHCOEnabled,
    fetchJourneyMetadata,
    fetchLocalization,
    journeyBuilderDecisionSplitStart,
  }
)(enhance);



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/JourneyBuilderDecisionSplitContainer.js